import { getTypedTranslation } from 'syf-js-utilities';
import englishTranslations from './en';
import spanishTranslations from './es';
const getTranslation = () => getTypedTranslation({
    en: englishTranslations,
    es: spanishTranslations
});
export const t = (key, params) => getTranslation().t(key, params);
export default getTranslation;
//# sourceMappingURL=getTranslation.js.map